export default __webpack_public_path__ + "static/img2-e4778195092731c1713858eb5bacc222.png";